/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Internal Imports
 */
import { Dropdown, IDropdownProps } from '../../shared/dropdowns';

/**
 * Global Type Definition Imports
 */
import { ICondensedMasterTemplate } from '../../../config/interfaces';

/**
 * Style Imports
 */
import { StyledLabel } from './Header.styles';

interface RoundTemplateSelectProps extends IDropdownProps {
  options: ICondensedMasterTemplate[];
  searchResults?: ICondensedMasterTemplate[];
  selectedTemplate?: ICondensedMasterTemplate;
  handleTemplateSelect: (template: ICondensedMasterTemplate) => void;
  setActiveSearch: Dispatch<SetStateAction<string>>;
  setQuery: Dispatch<SetStateAction<string>>;
}

const RoundTemplateSelect: FC<RoundTemplateSelectProps> = ({
  focused,
  options = [],
  query,
  searchResults,
  selectedTemplate,
  handleTemplateSelect,
  setActiveSearch,
  setQuery,
  ...rest
}) => {
  return (
    <div className="d-flex flex-column">
      <StyledLabel className="neu-text-body">Template</StyledLabel>
      <Dropdown classes="ps-0" focused={focused} query={query} {...rest}>
        {focused && searchResults && searchResults.length > 0 ? (
          [...searchResults].map((template: ICondensedMasterTemplate) => {
            const selected =
              options.length > 0 && template.name === selectedTemplate?.name;
            return (
              <div
                aria-selected={selected}
                className={`dropdown-hover-item${selected ? ' selected' : ''}`}
                key={template.templateConfigId}
                role="option"
                tabIndex={0}
                onClick={() => {
                  handleTemplateSelect(template);
                  setActiveSearch('');
                  setQuery('');
                }}
                onKeyDown={() => {
                  handleTemplateSelect(template);
                  setActiveSearch('');
                  setQuery('');
                }}
              >
                {template.name}
              </div>
            );
          })
        ) : searchResults && searchResults.length === 0 ? (
          <div className="dropdown-search-no-result">No results found!</div>
        ) : (
          [...options].map((template: ICondensedMasterTemplate) => {
            const selected =
              options.length > 0 && template.name === selectedTemplate?.name;
            return (
              <div
                aria-selected={selected}
                role="option"
                tabIndex={0}
                className={`dropdown-hover-item${selected ? ' selected' : ''}`}
                key={template.templateConfigId}
                onClick={() => handleTemplateSelect(template)}
                onKeyDown={() => handleTemplateSelect(template)}
              >
                {template.name}
              </div>
            );
          })
        )}
      </Dropdown>
    </div>
  );
};

export default RoundTemplateSelect;
